//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appConst from '@/tools/appConst.js';
import SubscribeHero2026AiPartners from '@/components/subscribe2026/SubscribeHero2026AiPartners.vue';

const DEFAULT_COIN_AMOUNT = 1000;

export default {
  name: 'SubscribeHeroAiCoinsCard',
  components: {
    SubscribeHero2026AiPartners,
  },
  props: {
    coinAmount: {
      type: Number,
      default: DEFAULT_COIN_AMOUNT,
    },
    models: {
      type: Array,
      default: () => appConst.AI_PARTNERS,
    },
  },
  computed: {
    coinAmountDisplay() {
      return this.$n(this.coinAmount, { useGrouping: false });
    },
  },
};
